import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomSwitch from "../../components/custom-ui/CustomSwitch";
import Twitter from "../../pics/Twitter Logo V2.png";
import apisecured from "../../api/apisecured";
import { toast } from "react-toastify";
import API from "../../api/api"; // your backend base
import { setTwitterConnection } from "../../State/authSlicer";
import OnboardingCompleteModal from "../../components/Dashcomponents/OnboardingCompleteModal";
import { useLocation, useNavigate } from "react-router-dom";

function IntegrationsSetting() {
  const userlogin = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [connected, setConnected] = useState(false);
  const [username, setUsername] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [receiveAllTips, setReceiveAllTips] = useState(true);
  const [receiveGoalFunded, setReceiveGoalFunded] = useState(true);
  const [receiveGeneralTips, setReceiveGeneralTips] = useState(false);

  const [loadingSettings, setLoadingSettings] = useState(false);
  const [saving, setSaving] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // handle success query param
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.get("success") === "true") {
      setShowSuccessModal(true);

      // remove success from URL
      searchParams.delete("success");

      navigate(
        `${location.pathname}${
          searchParams.toString() ? `?${searchParams.toString()}` : ""
        }`,
        { replace: true }
      );
    }
  }, [location.search, location.pathname, navigate]);

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("success");
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  // fetch Twitter status
  useEffect(() => {
    if (!userlogin.uid) return;

    const fetchStatus = async () => {
      try {
        const res = await apisecured.get("/account/twitter/status");
        const data = res.data;
        setConnected(data.connected);
        setUsername(data.username || "");
        dispatch(
          setTwitterConnection({
            connected: data.connected,
            username: data.username || "",
          })
        );
      } catch (err) {
        console.error("Error fetching Twitter status", err);
      }
    };

    fetchStatus();
  }, [userlogin.uid]);

  // fetch chatbot settings for Twitter
  useEffect(() => {
    if (!userlogin.uid) return;
    const fetchSettings = async () => {
      setLoadingSettings(true);
      try {
        const res = await apisecured.get("/account/get/chatbotsettings", {
          params: { platform: "Twitter" },
        });
        const data = res.data;

        setReceiveAllTips(data.receiveAllTips);
        setReceiveGoalFunded(data.receiveGoalFunded);
        setReceiveGeneralTips(data.receiveGeneralTips);
      } catch (err) {
        console.error("Failed to fetch Twitter integration settings", err);
      } finally {
        setLoadingSettings(false);
      }
    };
    fetchSettings();
  }, [userlogin.uid]);

  // const handleTwitterToggle = () => {
  //   if (connected) {
  //     // disconnect
  //     handleTwitterDisconnect();
  //   } else {
  //     // connect
  //     window.location.href = `${API}account/twitter/connect`;
  //   }
  // };
  const handleTwitterToggle = async () => {
    if (connected) {
      handleTwitterDisconnect();
    } else {
      try {
        // Make axios call so JWT gets sent
        const res = await apisecured.get("/account/twitter/connect-url");

        // Now redirect browser to actual Twitter connect URL
        window.location.href = res.data.url;
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleTwitterDisconnect = async () => {
    try {
      const res = await apisecured.post("/account/twitter/disconnect");
      if (res.data.success) {
        toast.success("X/Twitter disconnected successfully!");
        setConnected(false);
        setUsername("");
        dispatch(setTwitterConnection({ connected: false, username: "" }));
      }
    } catch (err) {
      toast.error("Failed to disconnect X/Twitter");
      console.error("Twitter disconnect error", err);
    }
  };

  const handleSaveChanges = async () => {
    setSaving(true);
    try {
      await apisecured.post("/account/settings/chatbot", {
        platform: "Twitter",
        receiveAllTips,
        receiveGoalFunded,
        receiveGeneralTips,
      });
      toast.success("Twitter settings saved successfully!");
    } catch (error) {
      const errMsg =
        error?.response?.data?.error || "An unknown error occurred.";
      toast.error(`Failed to save settings: ${errMsg}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <OnboardingCompleteModal
        open={showSuccessModal}
        onClose={handleCloseModal}
        onModalClose={handleCloseModal}
      />

      {/* Connection header */}
      <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold !text-left "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          X/Twitter
        </h2>

        <h2 className="CustomSignUpLabel !font-medium !ml-0 mt-2">
          Automatically post tweets when you receive a tip or when a goal is
          fully funded!
        </h2>

        <div className="rounded-xl  bg-[#030021]  ">
          <div className="rounded-xl  bg-[#35334D99] space-y-6 p-6 mt-4 ">
            <div className="flex items-center gap-3 text-white">
              <CustomSwitch
                isActive={connected}
                onClick={handleTwitterToggle}
              />
              <div className="flex items-center gap-3">
                <img
                  src={Twitter}
                  alt="X / Twitter"
                  className="w-[30px] min-w-[30px] h-[30px]"
                />
                <div>
                  <p
                    className="text-white font-bold"
                    style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                  >
                    X/Twitter
                  </p>
                  {connected ? (
                    <p className="text-gray-300 text-sm font-medium">
                      Connected as{" "}
                      <span className="font-bold LinkUnderline">
                        @{username}
                      </span>
                    </p>
                  ) : (
                    <p className="text-gray-300 text-sm font-medium">
                      Not connected —{" "}
                      <span
                        className="underline text-[#00FF8F] cursor-pointer"
                        onClick={handleTwitterToggle}
                      >
                        Connect
                      </span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Customisation */}
      <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold !text-left "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          X Integration Customisation
        </h2>

        <h2 className="CustomSignUpLabel !font-semibold !ml-0 mt-3">
          Customise your X/Twitter Integration here! (Coming Soon)
          <span className="block !font-[400] italic ">
            Available variables:{" "}
            {`{goal}, {user}, {amount}, {currency}, {goal URL}`}
          </span>
        </h2>

        {/* Tips towards goals */}
        <div className="rounded-xl  bg-[#030021]">
          <div className="rounded-tl-xl rounded-tr-xl  bg-[#35334D99] space-y-6 p-6 mt-4 ">
            <div className="flex items-center gap-3 text-white">
              <CustomSwitch
                isActive={receiveAllTips}
                onClick={() => setReceiveAllTips((prev) => !prev)}
              />
              <div>
                <p
                  className="text-white font-bold"
                  style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                >
                  Tips (Towards Goals)
                </p>
                <p className="text-gray-300 text-sm font-medium">
                  Automatically tweet for each tip you receive towards goals.
                </p>
              </div>
            </div>
          </div>
          <div className=" p-6 font-normal text-[15px] leading-[100%] tracking-[0%] text-white">
            {`I just received a tip towards “{goal}” from {user} on SPONSA! Thank you! {goal URL} #SPONSA`}
          </div>
        </div>

        {/* Fully funded */}
        <div className="rounded-xl  bg-[#030021]">
          <div className="rounded-tl-xl rounded-tr-xl  bg-[#35334D99] space-y-6 p-6 mt-4 ">
            <div className="flex items-center gap-3 text-white">
              <CustomSwitch
                isActive={receiveGoalFunded}
                onClick={() => setReceiveGoalFunded((prev) => !prev)}
              />
              <div>
                <p
                  className="text-white font-bold"
                  style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                >
                  Fully Funded Goals
                </p>
                <p className="text-gray-300 text-sm font-medium">
                  Automatically tweet when a goal is fully funded.
                </p>
              </div>
            </div>
          </div>
          <div className=" p-6 font-normal text-[15px] leading-[100%] tracking-[0%] text-white">
            {`My goal “{goal}” just got fully funded on SPONSA! Thank you! {goal URL} #SPONSA`}
          </div>
        </div>

        {/* General tips */}
        <div className="rounded-xl  bg-[#030021]">
          <div className="rounded-tl-xl rounded-tr-xl  bg-[#35334D99] space-y-6 p-6 mt-4 ">
            <div className="flex items-center gap-3 text-white">
              <CustomSwitch
                isActive={receiveGeneralTips}
                onClick={() => setReceiveGeneralTips((prev) => !prev)}
              />
              <div>
                <p
                  className="text-white font-bold"
                  style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                >
                  General Tips
                </p>
                <p className="text-gray-300 text-sm font-medium">
                  Automatically tweet for each General Tip you receive (tips
                  that don’t go towards a specific goal).
                </p>
              </div>
            </div>
          </div>
          <div className=" p-6 font-normal text-[15px] leading-[100%] tracking-[0%] text-white">
            {`I just received a tip from {user} on SPONSA! Thank you! https://sponsa.app/${userlogin.sponsaUserName} #SPONSA`}
          </div>
        </div>

        <button
          disabled={saving || loadingSettings}
          onClick={handleSaveChanges}
          className=" mx-auto mt-6  font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[25px]  px-[2rem] py-[0.5rem]  HoverDarker "
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </>
  );
}

export default IntegrationsSetting;
